
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Paintingwork() {



  const cardData =
  {
    keyword: ' All Types of Painting Work Services',
    heading: 'Anjali Enterprises:All Types of Painting Work Services ',
    headingDescription: 'Anjali Enterprises offers a comprehensive range of painting services in Pune, designed to enhance the look and feel of your home or business. Whether youare looking to freshen up your interiors, give your office a modern makeover, or protect your building from the elements, we have the expertise to deliver high-quality painting solutions tailored to your needs.',

    "topPlaces": [
        {
          "title": "Interior and Exterior Painting Services",
          "description": "We provide both interior and exterior painting services to give your property a vibrant and fresh look. Whether you're updating your living room, office space, or the exterior of your building, our painting services offer durability and aesthetic appeal."
        },
        {
          "title": "Residential and Commercial Painting",
          "description": "Anjali Enterprises offers expert painting services for both residential and commercial properties. Whether you're renovating your home or refreshing your office, we deliver professional results that match your specific requirements."
        },
        {
          "title": "Painting Contractors Pune",
          "description": "As trusted painting contractors in Pune, we bring years of experience and high standards to every painting project. Our skilled team uses premium paints and techniques to ensure that your property looks its best."
        },
        {
          "title": "High-Quality Wall Painting",
          "description": "Our high-quality wall painting services are designed to provide smooth, lasting finishes. We use top-grade paints that offer vibrant colors and durability, ensuring that your walls remain fresh and beautiful for years to come."
        },
        {
          "title": "Home Painting Services",
          "description": "Transform the look of your home with our specialized home painting services. From minor touch-ups to full room makeovers, we offer customized painting solutions that suit your preferences and elevate your living space."
        },
        {
          "title": "Industrial Painting Solutions",
          "description": "Our industrial painting services are tailored to meet the demanding needs of factories, warehouses, and industrial buildings. We offer durable, high-performance coatings that withstand the harsh conditions of industrial environments."
        },
        {
          "title": "Waterproof Painting",
          "description": "Protect your property from water damage with our waterproof painting solutions. Ideal for areas exposed to moisture, such as bathrooms, basements, and exterior walls, our waterproof coatings help prevent leaks and water-related issues."
        },
        {
          "title": "Decorative Painting",
          "description": "Add a touch of elegance and style to your space with our decorative painting services. Whether you want custom murals, textured walls, or unique finishes, our team can create personalized designs that enhance your interiors."
        },
        {
          "title": "House Painting Work",
          "description": "We specialize in house painting work that brings beauty and charm to your home. From choosing the right colors to perfecting the finish, we ensure that every detail is meticulously executed to transform your living space."
        },
        {
          "title": "Painting Services for Offices",
          "description": "Our office painting services are designed to create a professional, welcoming environment. Whether you're painting individual workstations, conference rooms, or the entire office, we offer customized solutions that match your business’s style."
        },
        {
          "title": "Custom Painting Services",
          "description": "If you're looking for a unique look, our custom painting services provide personalized solutions that reflect your taste. From personalized designs to specific color choices, we bring your vision to life with precision and creativity."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality painting work. We specialize in all types of painting services, including interior and exterior painting, wall painting, decorative finishes, and industrial painting, offering long-lasting and aesthetically pleasing results. Get in touch for expert service and professional results. Serving Pune with top-notch painting work tailored to your specific requirements."
        }
      ],
      "tableData": [
        ["- Interior and exterior painting services", "- Residential and commercial painting"],
        ["- Painting contractors Pune", "- High-quality wall painting"],
        ["- Home painting services", "- Industrial painting solutions"],
        ["- Waterproof painting", "- Decorative painting"],
        ["- House painting work", "- Painting services for offices"],
        ["- Custom painting services", "- Contact Anjali Enterprises for expert service"]
      ],


    "whychoose": [
  {
    "WhyChooseheading": "Comprehensive Painting Services",
    "WhyChoosedescription": "At Anjali Enterprises, we offer a full spectrum of painting services to meet the needs of residential, commercial, and industrial clients. Whether you're looking to refresh a single room, repaint your entire property, or give your office or business a complete makeover, we have the experience and expertise to handle projects of any size. Our team is equipped to manage everything from intricate interior details to large-scale exterior jobs, delivering exceptional results every time."
  },
  {
    "WhyChooseheading": "Skilled and Experienced Painters",
    "WhyChoosedescription": "Our team is composed of highly skilled and experienced painters who are trained in the latest painting techniques and best practices. From precise color matching to applying paint with a perfect finish, we take great pride in our craftsmanship. Our painters are meticulous about their work, ensuring that every stroke and layer of paint is applied with precision, creating a smooth, flawless, and long-lasting finish on all surfaces."
  },
  {
    "WhyChooseheading": "High-Quality Paints and Materials",
    "WhyChoosedescription": "We believe in using only the best materials to achieve superior results. At Anjali Enterprises, we source premium-quality paints from trusted and reputable brands. Our selection ensures not only the perfect color match but also durability, color accuracy, and long-lasting coverage. Whether it's for interior walls, exterior surfaces, or specialized areas, we use the right products designed to withstand the conditions and provide a beautiful finish."
  },
  {
    "WhyChooseheading": "Custom Solutions",
    "WhyChoosedescription": "We understand that every project is unique, and we offer tailored painting solutions to suit your vision and preferences. Whether you already have a specific color scheme in mind or need assistance in selecting the perfect shades, our team works closely with you to create a personalized design that complements your space. From accent walls to custom finishes, we ensure your painting project enhances the aesthetic of your home or business."
  },
  {
    "WhyChooseheading": "Timely Completion",
    "WhyChoosedescription": "At Anjali Enterprises, we value your time and are committed to completing painting projects within the agreed-upon timeframe. Our team works efficiently and in an organized manner to ensure that your space is transformed on schedule, with minimal disruption to your daily life or business operations. We prioritize timely delivery without compromising on quality, ensuring you get the results you expect when you expect them."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We strive to provide excellent value for your investment. Our painting services are competitively priced, and we believe in complete transparency when it comes to costs. Before we start any project, we provide clear, detailed quotes with no hidden charges, so you know exactly what to expect. Our goal is to offer high-quality, professional painting services that fit within your budget, ensuring you receive top-notch results without any surprises."
  },
  {
    "WhyChooseheading": "Surface Preparation and Finishing",
    "WhyChoosedescription": "We understand that surface preparation is crucial to achieving a flawless paint job. At Anjali Enterprises, we take the time to properly prepare all surfaces before applying any paint, ensuring that the paint adheres properly and lasts longer. Our preparation process includes cleaning, sanding, patching, and priming, providing a smooth base for the paint. Our attention to detail continues through to the finishing stage, where we apply touch-ups and detailing to ensure a polished, professional look."
  },
  {
    "WhyChooseheading": "Eco-Friendly Painting Options",
    "WhyChoosedescription": "We are committed to sustainability and offer eco-friendly painting options for those who want to make environmentally conscious choices. We use low-VOC (volatile organic compound) paints and other safe, non-toxic materials that are better for both your health and the environment. Whether you're concerned about air quality or want to minimize your carbon footprint, we can help you choose the right eco-friendly paints and finishes to suit your needs."
  },
  {
    "WhyChooseheading": "Interior and Exterior Painting",
    "WhyChoosedescription": "Our painting expertise covers both interior and exterior surfaces, offering complete solutions for every area of your property. Whether you're looking to refresh the look of your living room, add curb appeal with a vibrant exterior color, or give your business a professional finish, our team is ready to tackle projects of all sizes. We use the latest tools and techniques to ensure that your interior walls, ceilings, and exteriors are transformed with a high-quality, durable finish that lasts."
  }
]



  }

  const faqData = [
    {
      "question": "What types of painting services do you offer?",
      "answer": "We offer a range of painting services, including interior and exterior painting, wall and ceiling painting, decorative finishes, texture painting, industrial painting, and more. We can handle both residential and commercial painting projects."
    },
    {
      "question": "Do you provide custom color consultations?",
      "answer": "Yes, we offer custom color consultations to help you choose the perfect color scheme for your space. Our team will work with you to understand your preferences and suggest colors that complement your interiors and exteriors."
    },
    {
      "question": "How long does a painting project take?",
      "answer": "The timeline for a painting project depends on the size of the space and the complexity of the work. Typically, our team completes projects efficiently while ensuring high-quality results. We provide a timeline before starting the project and keep you updated on the progress."
    },
    {
      "question": "What kind of paints do you use?",
      "answer": "We use high-quality paints from trusted brands to ensure long-lasting, durable finishes. We offer a range of paint types, including matte, satin, gloss, and textured finishes, to suit different surfaces and your aesthetic preferences."
    },
    {
      "question": "How do you prepare surfaces before painting?",
      "answer": "Surface preparation is essential for a perfect paint finish. We clean, sand, and repair any imperfections on the surfaces to ensure smoothness. For exterior projects, we may power wash surfaces to remove dirt and debris before painting."
    },
    {
      "question": "Is your painting work safe for children and pets?",
      "answer": "Yes, we offer eco-friendly and low-VOC (volatile organic compound) paints that are safe for children, pets, and the environment. These paints have low toxicity and odor, making them a healthier option for your home or office."
    },
    {
      "question": "Do you offer both residential and commercial painting services?",
      "answer": "Yes, we provide painting services for both residential and commercial properties. Whether it’s a home makeover or a large commercial space, we have the experience and equipment to complete projects of all sizes."
    },
    {
      "question": "Can you handle large-scale painting projects?",
      "answer": "Yes, we have the capacity to handle large-scale painting projects, such as multi-story buildings, offices, or industrial spaces. Our experienced team is equipped to manage projects of any size, ensuring a high standard of work and timely completion."
    },
    {
      "question": "How do I get an estimate for my painting project?",
      "answer": "You can contact us to schedule an on-site consultation, where we’ll assess the scope of work and provide you with a detailed, free estimate. Our quotes are transparent and include all necessary labor, materials, and costs."
    },
    {
      "question": "Why should I choose Anjali Enterprises for my painting work?",
      "answer": "Anjali Enterprises offers top-quality painting services with a focus on customer satisfaction. Our experienced painters, high-quality materials, affordable pricing, and commitment to eco-friendly options make us the ideal choice for your painting projects. We ensure a flawless finish, whether it’s for a home, office, or commercial space."
    }
  ];
  
  const testimonials = [
    {
      "name": "Mr. Rajesh Kumar",
      "text": "I hired Anjali Enterprises for painting my house, and the result was amazing. The team was professional, worked efficiently, and delivered a perfect finish. They even helped me select the right colors! Highly recommend them for any painting needs."
    },
    {
      "name": "Ms. Shalini Agarwal",
      "text": "Anjali Enterprises painted our office space, and we couldn’t be happier with the results. The team was quick, reliable, and paid great attention to detail. The new look is fresh and professional. Definitely the best in town for painting services!"
    }
  ];
  

  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>

<Helmet>
  <title> All Types of Painting Work Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers all types of painting work services in Pune, including interior and exterior painting, residential and commercial painting, waterproof painting, decorative painting, and industrial painting. Call +91 8793220265 for expert painting services." />
  <meta name="keywords" content="Interior and Exterior Painting Services, Residential and Commercial Painting, Painting Contractors Pune, High-Quality Wall Painting, Home Painting Services, Industrial Painting Solutions, Waterproof Painting, Decorative Painting, House Painting Work, Painting Services for Offices, Custom Painting Services" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | All Types of Painting Work Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers all types of painting work services in Pune, including interior and exterior painting, residential and commercial painting, waterproof painting, decorative painting, and industrial painting. Call +91 8793220265 for expert painting services." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/painting-work-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/painting-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers all types of painting work services in Pune, including interior and exterior painting, residential and commercial painting, waterproof painting, decorative painting, and industrial painting. Call +91 8793220265 for expert painting services.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/painting-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/painting-work-service.jpg",
        "priceRange": "₹5000 - ₹100000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/painting-services",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "45"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya R"
            },
            "datePublished": "2024-07-12",
            "reviewBody": "We hired Anjali Enterprises for both interior and exterior painting at our home. The team did a fantastic job. The work was completed on time and to a very high standard!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikas K"
            },
            "datePublished": "2024-09-03",
            "reviewBody": "Anjali Enterprises painted our office space and the results were great! They were professional, fast, and the quality was beyond expectations."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/painting-services"
        },
        "keywords": "Interior and Exterior Painting Services, Residential and Commercial Painting, Painting Contractors Pune, High-Quality Wall Painting, Home Painting Services, Industrial Painting Solutions, Waterproof Painting, Decorative Painting, House Painting Work, Painting Services for Offices, Custom Painting Services"
      }
    `}
  </script>
</Helmet>




      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/19.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Paintingwork;